import { type PropsWithChildren, ReactNode } from 'react'
import { cn } from '../../../utils'

export interface ZugmeldestelleWrapperProps extends PropsWithChildren {
  betriebsstellenartField: ReactNode
  bestriebsstelleField: ReactNode
  className?: string
}

export default function ZugmeldestelleWrapper({
  betriebsstellenartField,
  bestriebsstelleField,
  className
}: Readonly<ZugmeldestelleWrapperProps>) {
  return (
    <div className={cn('@container', className)}>
      <div className="flex flex-col @[370px]:flex-row w-full gap-0.5">
        <div className="basis-full @[370px]:basis-auto @[370px]:min-w-[33.33%] flex-shrink-0">
          {betriebsstellenartField}
        </div>
        <div className="w-full @[370px]:flex-1">{bestriebsstelleField}</div>
      </div>
    </div>
  )
}
